import { RootState } from 'models/store';

export const selectBalanceGroupDetail = (state: RootState) =>
  state.eai.balanceGroup.balanceGroupDetail;

export const selectBalanceGroupCharacteristics = (state: RootState) =>
  state.eai.balanceGroup.balanceGroupCharacteristics;

export const selectBalanceGroupDeliveryPointList = (state: RootState) =>
  state.eai.balanceGroup.deliveryPointList.partyList;

export const selectBalanceGroupDeliveryPointListPage = (state: RootState) =>
  state.eai.balanceGroup.deliveryPointList.page;

export const selectBalanceGroupsList = (state: RootState) =>
  state.eai.balanceGroup.balanceGroupsList.balanceGroupsList;

export const selectBalanceGroupsListPage = (state: RootState) =>
  state.eai.balanceGroup.balanceGroupsList.page;
